var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTag24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4674 13.8944L13.9007 20.4627C13.5571 20.8067 13.0909 21 12.6047 21C12.1186 21 11.6524 20.8067 11.3088 20.4627L3.44163 12.6027C2.60811 8.71479 2.95446 6.00755 4.48069 4.48095C6.00691 2.95434 8.7134 2.60799 12.6002 3.44189L20.4674 11.311C21.1775 12.0256 21.1775 13.1797 20.4674 13.8944Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.021 8.02229H8.03015",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTag24);
export default __webpack_public_path__ + "static/media/icon-tag-24.a68a53705caf58d5667d1414eac18ba3.svg";
export { ForwardRef as ReactComponent };